import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_CONFIG } from './app/app.models';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// delay application bootstrap until application configuration is loaded
// provide config as InjectionToken
// cant use APP_INITIALIZER from angular because providers get resolved in parallel
//
// might use fetch-API later, currently not supported by IE11
const req = new XMLHttpRequest();
req.open('GET', 'assets/app-config.json');
req.onload = () => {
    const config = JSON.parse(req.response);
    if (environment.production) {
        enableProdMode();
    }
    const bootstrap = () => platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }]).bootstrapModule(AppModule);

    bootstrap();
};
req.send();
